import { render } from "./TabsComponent.vue?vue&type=template&id=1ee04e0e&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"

import "./TabsComponent.vue?vue&type=style&index=0&id=1ee04e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee04e0e"]])

export default __exports__